module.exports = __webpack_public_path__ + "babbf67a7aec600a3d85eb6f7409beb8.jpg";